module.exports = __webpack_public_path__ + "static/media/icon_flag.fd39611e.svg";